import { useCallback } from 'react';
import {
  templateMarketplaceFavoritesPageViewSrc80Evid3410,
  templateMarketplaceFavoritesGenericClickSrc80Evid3411,
} from '@wix/bi-logger-partners-data/v2';
import { useBi } from '@components/Hooks/useBi';
import useMobileMediaQuery from '@components/Hooks/useMobileMediaQuery';
import { TEMPLATES_FAVORITES_ENTRY } from '@utils/constants';

export const FAVORITES_BI_CLICK_TYPES = {
  addToFavorites: 'Add to favorites',
  removeFromFavorites: 'Remove from favorites',
  viewTemplate: 'View template',
  goToTemplatePage: 'go to template page',
  useFreeTemplate: 'Use free template',
  purchase: 'purchase',
  exploreTemplates: 'Explore templates',
  viewAllTemplates: 'View all templates',
  favorites: 'Favorites',
} as const;

type FavoritesClickParams = {
  click_type: string;
  selected_template_id?: string;
  selected_template_owner_account_id?: string;
};

export const useFavoritesBi = ({
  favoriteTemplateIds,
}: {
  favoriteTemplateIds?: string[];
} = {}) => {
  const logger = useBi();
  const isMobileView = useMobileMediaQuery(false);
  const origin =
    typeof document !== 'undefined' ? document.referrer : undefined;
  const favoritesTemplateIdsParam =
    favoriteTemplateIds && favoriteTemplateIds.length > 0
      ? favoriteTemplateIds.join(',')
      : undefined;

  const logPageView = useCallback(() => {
    logger.report(
      templateMarketplaceFavoritesPageViewSrc80Evid3410({
        entry: TEMPLATES_FAVORITES_ENTRY,
        ...(origin && { origin }),
        ...(favoritesTemplateIdsParam && {
          favorites_template_ids: favoritesTemplateIdsParam,
        }),
        ...(isMobileView && { is_mobile: isMobileView }),
      }),
    );
  }, [logger, favoritesTemplateIdsParam, isMobileView, origin]);

  const logClick = useCallback(
    ({
      click_type,
      selected_template_id,
      selected_template_owner_account_id,
    }: FavoritesClickParams) => {
      logger.report(
        templateMarketplaceFavoritesGenericClickSrc80Evid3411({
          entry: TEMPLATES_FAVORITES_ENTRY,
          ...(origin && { origin }),
          click_type,
          ...(isMobileView && { is_mobile: isMobileView }),
          ...(selected_template_id && { selected_template_id }),
          ...(selected_template_owner_account_id && {
            selected_template_owner_account_id,
          }),
        }),
      );
    },
    [logger, isMobileView, origin],
  );

  return { logPageView, logClick };
};
